import React from 'react'

function AutomotiveEngineers() {
  return (
    <div className="container Detail">
    <h6>Automotive Engineers</h6>
   <p>Here is a list of automotive engineers in Ethiopia...</p>
    </div>
  )
}

export default AutomotiveEngineers;